<template>
  <div class="col-sm-12">
    <div class="card profile-header">
      <div class="profile-img-wrrap"></div>
      <div class="userpro-box">
        <div class="img-wrraper">
          <div class="avatar" id="profile-tour"><img class="img-fluid" alt="" src="@/assets/images/user/7.jpg"></div><router-link
            class="icon-wrapper" id="update-profile-tour" to="/users/edit"><i
              class="icofont icofont-pencil-alt-5"></i></router-link>
        </div>
        <div class="user-designation">
          <div class="title"><a target="_blank" href="">
              <h4>Emay Walter</h4>
            </a>
            <h6>designer</h6>
          </div>
          <div class="social-media">
            <ul class="user-list-social">
              <li><a href="https://www.facebook.com" target="_blank"><i class="fa fa-facebook"></i></a></li>
              <li><a href="https://www.google.com" target="_blank"><i class="fa fa-google-plus"></i></a></li>
              <li><a href="https://www.twitter.com" target="_blank"><i class="fa fa-twitter"></i></a></li>
              <li><a href="https://www.instagram.com" target="_blank"><i class="fa fa-instagram"></i></a></li>
              <li><a href="https://www.rss.com" target="_blank"><i class="fa fa-rss"></i></a></li>
            </ul>
          </div>
          <div class="follow">
            <ul class="follow-list">
              <li>
                <div class="follow-num counter">
                  <number :from="0" :to="325">325</number>
                </div><span>Follower</span>
              </li>
              <li>
                <div class="follow-num counter">
                  <number :from="0" :to="450">450</number>
                </div><span>Following</span>
              </li>
              <li>
                <div class="follow-num counter">
                  <number :from="0" :to="500">500</number>
                </div><span>Likes</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
}
</script>